// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__PEIKJ","errors":"Errors_errors__3jRO7"};